// @ts-nocheck
// tslint:disable
export var $location = {
  href: '',
  protocol: '',
  host: ''
};